import React, { useState } from 'react'
import ChaseDisplayCard from '../components/chase-display-card'
import UseChaseProvider from '../utils/use-chase-provider'
import ChaseLicenseQuestionCard from '../components/chase-license-question-card'
import ChaseModel from '../components/chase-model'
import { chaseItemDataTypes } from '../utils/data/chase-item-data'
import ChaseFileUploader from '../components/chase-file-uploader'
import CustomButton from '../components/custom-button'
import axiosInstance from '../utils/axiosInstance'
import { toast } from 'react-toastify'
import { ParseErrors } from '../utils/parse-errors'
import HelpCard from '../components/help-card'
import ChatCard from '../components/chat-card'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPhone } from '@fortawesome/free-solid-svg-icons'


const Home: React.FC = () => {
    const { chase, chaseType, newFiles, isMessage, onSetChaseType, driverId, onSetDriverId, isUploading } = UseChaseProvider()
    const [loading, setLoading] = useState<boolean>(false)


    const onSubmitValues = async () => {
        setLoading(true)
        try {
            await axiosInstance.patch(`/chase/public/${chase?.policyReferenceNumber}`, {
                chaseType: chaseType,
                chaseBodyData: newFiles,
                chaseBodyDataType: "files",
                driverId
            })
            toast.success("Updated Successfully")
            setLoading(false)
            onSetChaseType()
            onSetDriverId()
        } catch (error) {
            toast.error(ParseErrors(error))
            setLoading(false)
        }
    }
    const chaseDetails = chaseItemDataTypes.find((chaseItemData) => chaseItemData.id === chaseType)

    return (
        <>
            {isMessage ? <ChatCard /> : <>
                {!chaseType && <ChaseDisplayCard />}
                {chaseType === "driversLicenseSummary" && <ChaseLicenseQuestionCard />}
                {chaseType && chaseType !== "driversLicenseSummary" && <>
                    <ChaseModel>
                        <div>

                            <h2 className='text-white text-title'>{chaseDetails?.label}</h2>

                            <div className='mt-4'>
                                <HelpCard />
                            </div>

                            {chaseType === "disclosedClaims" && <div className='w-full mt-5 p-4 surface-row'>
                                <CustomButton variant='outlined' onClick={() => { document.location.href = "tel:03300419368" }}>
                                    <FontAwesomeIcon icon={faPhone} /> 0330 041 9368
                                </CustomButton>
                                <p className='text-white/[0.66] mt-3 text-[14px] leading-[21px] text-center'>For more information regarding the undisclosed claims we’ve found, please call our friendly team on the number above 👆</p>
                            </div>}

                            <p className='text-white/[0.66] mt-5 text-[14px] leading-[21px]'>Note: You can upload multiple files/images, up to 20 MB each. You can choose to take a new photo or upload a file or image below.</p>

                            <div className='mt-5 mb-6'>
                                <ChaseFileUploader />
                            </div>

                            <CustomButton disabled={!newFiles.length || isUploading} onClick={onSubmitValues} loading={loading}>
                                Submit
                            </CustomButton>
                        </div>
                    </ChaseModel>
                </>}
            </>}
        </>
    )
}

export default Home
